import * as React from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import { Authorize } from '../Authorize/Authorize';
import { Lobby } from '../Lobby/Lobby';
import { ProductConfigurator, Source } from '../Configurator/ProductConfigurator';
import { useEffect, useState } from 'react';
import { embeddingService } from '@/ui-kit/services/embedding/EmbeddingService';

function AppImpl() {
  const [embedded, setEmbedded] = useState(false);

  useEffect(() => {
    embeddingService.start();
    embeddingService.awaitBootstrapping().then(() => {
      setEmbedded(true);
    });
    return () => {
      embeddingService.stop();
    };
  }, []);
  if (!embedded) {
    return null;
  }

  return (
    <>
      <Router>
        <Routes>
          {/*TODO: Make redirect*/}
          {/*<Route path="/configurator/:configuratorId/:configurationId?" element={<ProtectedConfigurator />}>*/}
          {/*</Route>*/}
          {/*<Route path="/configurator/:projectId/:productId?" element={<ProtectedConfigurator />} />*/}
          <Route
            path="/configurator/backend-driven/:projectId/product/:productId"
            element={<ProductConfigurator composite={false} source={Source.Backend} />}
          />
          <Route
            path="/configurator/backend-driven/:projectId/composite/:productId"
            element={<ProductConfigurator composite={true} source={Source.Backend} />}
          />
          <Route
            path="/configurator/demo/:projectId/composite/:productId"
            element={<ProductConfigurator composite={true} source={Source.Local} />}
          />
          <Route
            path="/configurator/demo/:projectId/product/:productId"
            element={<ProductConfigurator composite={false} source={Source.Local} />}
          />
          <Route
            path="/configurator/bucket/:projectId/composite/:productId"
            element={<ProductConfigurator composite={true} source={Source.Bucket} />}
          />
          <Route
            path="/configurator/bucket/:projectId/product/:productId"
            element={<ProductConfigurator composite={false} source={Source.Bucket} />}
          />
          <Route path="/authorize" element={<Authorize />} />
          <Route path="/" element={<Lobby />} />
        </Routes>
      </Router>
    </>
  );
}

export const App = AppImpl;
